import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import './style.scss'

export default class TipPreview extends Component {
  render() {
    const { imageSrc, url, title, text, modification, mobile } = this.props
    const className = 'tip-component'
    const currentClassName = !modification
      ? className
      : `${className} ${className}--${modification}`

    return (
      <div
        className={!mobile ? currentClassName : `${currentClassName} tip-component--visible-mobile`}
      >
        <Link to={url} className='tip-component__link'>
          <img
            src={imageSrc}
            alt={title}
            className='tip-component__image'
            width={106}
            height={106}
          />
          <div className='tip-component__info'>
            <h3 className='tip-component__title'>{title}</h3>
            <p className='tip-component__text'>{text}</p>
          </div>
        </Link>
      </div>
    )
  }
}
